import { render, staticRenderFns } from "./StatusHeader.vue?vue&type=template&id=0ae9233e&"
import script from "./StatusHeader.vue?vue&type=script&lang=js&"
export * from "./StatusHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports